module.exports = __webpack_public_path__ + "images/resume_searches/icon-close-dd64e75f8e0d64315048f47395794467.svg";